import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

/**
 * La app funciona sin Supabase: Dexie es la fuente de verdad en el cliente y
 * la nube solo sincroniza. Asi se puede usar y probar antes de haber creado la
 * cuenta (SETUP.md paso 1) y no se rompe si alguien despliega sin variables.
 */
export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url!, anonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    })
  : null;

/** Lanza si se llama a algo que necesita nube sin tenerla configurada. */
export function requireSupabase(): SupabaseClient {
  if (!supabase) {
    throw new Error(
      'Supabase no está configurado. Rellena VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY (ver SETUP.md).',
    );
  }
  return supabase;
}
